import Vue from 'vue'
import App from './App.vue';
import "regenerator-runtime";
import router from './router/intranet'
import store from './store'

import VueApollo from 'vue-apollo'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Storage from 'vue-ls'
import { apolloProvider } from './vue-apollo'
import { InMemoryCache } from 'apollo-cache-inmemory'
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core/dist/umd/popper.min.js";
import "bootstrap/dist/js/bootstrap.esm.min.js";
import './assets/scss/pages/intranet/main.scss'
import Emoji from './components/intranet/emoji/Emoji.vue'
import VueFormulate from '@braid/vue-formulate'
import { es } from '@braid/vue-formulate-i18n'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
//import 'v-calendar/style.css';


import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as regularIcons from '@fortawesome/free-regular-svg-icons'
import * as solidIcons from '@fortawesome/free-solid-svg-icons'

// Add all regular icons to the library
const validRegularIcons = Object.keys(regularIcons)
  .filter(key => key.startsWith('fa'))
  .map(key => regularIcons[key])

const validSolidIcons = Object.keys(solidIcons)
  .filter(key => key.startsWith('fa'))
  .map(key => solidIcons[key])

// Add all valid icons to the library
library.add(...validRegularIcons, ...validSolidIcons)

// Register the FontAwesomeIcon component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css'
Vue.use(VueCroppie);

// Use plugin defaults (optional)
Vue.use(setupCalendar, {})

// Use the components
Vue.component('VCalendar', Calendar)
Vue.component('VDatePicker', DatePicker)

const options = {
    namespace: 'vuejs__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
}
Vue.component('emoji-div', Emoji)
// Vue.component('NavVertical', NavVertical);



Vue.use(VueToast)
Vue.use(VueApollo)
Vue.use(VueAxios, axios)
Vue.use(Storage, options)
Vue.use(VueFormulate, {
    plugins: [ es ],
    locale: 'es',
    // rules: {
    //     validRut: ({ value }) => ChileanRutify.validRut(value) 
    // },
    locales: {
        es: {
            validRut: () => `RUT inválido.`,
            email: () => `El correo no está bien formado.`,
            required: () => `Campo requerido.`,
            confirm: () => `Las contraseñas no coinciden.`,
            min: ({ args }) => `La contraseña debe tener al menos ${args[0]} caracteres.`,
            matches: () => `La contraseña debe tener al menos un número, una mayúscula y un caracter especial.`
        }
    },
    classes: {
        errors: 'validation-messages'
    }

});

const cache = new InMemoryCache({
    /* Person: {
      // In a user account system, the combination of a person's name AND email
      // address might uniquely identify them.
        keyFields: ["name", "email"],
    }, */
    User: {
        keyFields: [],
    },
})

Vue.config.productionTip = false

import moment from "moment";
Vue.mixin({
    computed: {
        colorPrimario() {
            if (this.isUserLoggedIn()) {
              return `#${this.$ls.get("user").empresa[0].color_primario}`;
            //   return `#000000`;
            } else {
              return "";
            }
        },
        nowChileMoment() {
            return moment().utcOffset(-180);
        }
    },
    methods: {
        isUserLoggedIn() {
            return !!(this.$ls.get("user")?.id_usuario);
        },
      
        setModuleId(component, modulesList) {
            component.id_modulo = modulesList
            .find(modulo => component.nombre_modulo === modulo.moduloGeneral.nombre_modulo)
            .moduloGeneral.id_modulo;
        },
        capitalizeFirstLetter(texto) {
            return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase()
        },
        getBase64(file) {
            return new Promise(function(resolve, reject) {
                const reader = new FileReader()
                reader.onload = function() {
                    // console.log(reader.result)
                    resolve(reader.result)
                }
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },
        logOut() {
            this.$ls.clear();
            localStorage.clear();
            this.$router.push({ name: "Login" });
        },
		sanitizeUrl(url) {
            if (!url) return "";
			if (url.includes("http://") || url.includes("https://")) return;
			return `http://${url}`;
		},
        decodeJWT(token) {
            const parts = token.split('.');
            if (parts.length !== 3) {
              console.error('Token no tiene formato de JWT');
            }
            // const header = JSON.parse(atob(parts[0]));
            const payload = JSON.parse(atob(parts[1]));
            return payload;
        },
        toastGenericError() {
            this.$toast.open({
                message: "Error obteniendo información. Por favor recarga la página e intenta nuevamente.",
                type: "error",
                duration: 5000,
                position: "top-right",
            });
        }
    },
    filters: {
        userFullName(user) {
            if (!user.primer_nombre && !user.apellido_paterno) return "";
            return `${user.primer_nombre} ${user.apellido_paterno}`;
        },
        initials(sentence) {
            if (!sentence) return "";
            const words = sentence.split(' ');
            const firstCharacters = words.map(word => word.charAt(0));
            return firstCharacters.join('').toUpperCase();
        },
        capitalizeFirstChars(sentence) {
			if (!sentence) return "";
            const words = sentence.toLowerCase().split(' ');
            const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
            return capitalizedWords.join(' ');
		}

    }
})
Vue.prototype.$basePath = process.env.VUE_APP_BASE_PATH;

new Vue({
    router,
    store,
    cache,
    apolloProvider,
    render: (h) => h(App),
}).$mount('#app')
